import { useEffect, useState } from "react";
import axios from "axios";
import { Loader2 } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";

const API = `${process.env.REACT_APP_BACKEND_URL}/api/social-planner`;

export const ProductPicker = ({ onClose, onPick, allowNone }) => {
  const [items, setItems] = useState(null);
  const [q, setQ] = useState("");
  useEffect(() => { axios.get(`${API}/candidates`).then((r) => setItems(r.data.items || [])).catch(() => setItems([])); }, []);
  const shown = (items || []).filter((p) => p.title.toLowerCase().includes(q.toLowerCase()));

  return (
    <Dialog open onOpenChange={onClose}>
      <DialogContent data-testid="product-picker-dialog" className="max-h-[85vh] max-w-xl overflow-y-auto">
        <DialogHeader><DialogTitle>Alege produsul pentru postare</DialogTitle></DialogHeader>
        <p className="text-xs text-zinc-500">Doar produse active, cu stoc ≥ 10, nepostate în ultimele 30 de zile și neprogramate deja.</p>
        <Input data-testid="product-picker-search" value={q} onChange={(e) => setQ(e.target.value)} placeholder="Caută după nume" />
        {items === null ? <Loader2 className="mx-auto h-5 w-5 animate-spin" /> : (
          <div className="space-y-1">
            {allowNone && <button data-testid="product-picker-none" onClick={() => onPick("__none__")} className="w-full rounded-lg border border-dashed border-amber-400 px-3 py-2 text-left text-sm text-zinc-700 hover:bg-amber-50">Postare generală (fără produs) — textul trimite pe bragus.ro</button>}
            {!allowNone && <button data-testid="product-picker-auto" onClick={() => onPick("")} className="w-full rounded-lg border border-dashed border-zinc-300 px-3 py-2 text-left text-sm text-zinc-600 hover:border-amber-500">Alege automat următorul produs eligibil</button>}
            {shown.map((p) => (
              <button key={p.handle} data-testid={`product-picker-${p.handle}`} onClick={() => onPick(p.handle)} className="flex w-full items-center gap-3 rounded-lg px-2 py-1.5 text-left hover:bg-amber-50">
                <img src={p.image} alt="" className="h-11 w-11 shrink-0 rounded bg-white object-contain" />
                <span className="flex-1 text-sm text-zinc-800">{p.title}</span>
                <span className="text-xs text-zinc-500">{p.price} lei · {p.stock} buc</span>
              </button>
            ))}
            {shown.length === 0 && <p className="text-sm text-zinc-500">Niciun produs.</p>}
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
};
